import LendingPeriod from '../media/models/LendingPeriod';

export default class LendingPeriodCollection extends Backbone.Collection {
    get model() {
        return LendingPeriod;
    }
}
